import { ReactComponent as PFC } from "../../customIcons/PFC.svg";
import { ReactComponent as TANK } from "../../customIcons/Tanks4.svg";
import { ReactComponent as BARN } from "../../customIcons/Barn.svg";
import { ReactComponent as FIELD } from "../../customIcons/Field.svg";

import {useEffect, useState} from "react";

const TANKIcons = ({ selectedTank, size, color }) => {
    
    const [SelectedComponent, setSelectedComponent] = useState(null); // This will store the component itself
    const sharedClassName = `${size ? `${size}` : 'size-8'} ${color ? `${color}` : 'text-green-600'}`; // You can also move this to Tailwind config if reused widely

    
    useEffect(() => {
      const volumeMap = {
        "Tank": { component: TANK },
        "Barn": { component: BARN },
        "Field": { component: FIELD },
      };
    
      const volumeData = volumeMap[selectedTank];
    
      if (volumeData) {
        setSelectedComponent(volumeData.component);
      } else {
        setSelectedComponent(PFC);
      }
      
    }, [selectedTank]);
    

    return (
        <div className={`w-fit h-fit`}>

            {SelectedComponent ? (
              <SelectedComponent className={sharedClassName} />
            ) : (
              <PFC className={sharedClassName} />
            )}

            
        </div>
    )
}

export default TANKIcons;
